var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36663 9.98936L1.96543 10.4564C1.70483 10.5432 1.4569 10.2954 1.54383 10.0348L2.0109 8.63356C2.04097 8.54329 2.02863 8.44609 1.98023 8.36409C1.4099 7.39769 1.1723 6.21203 1.44757 4.95803C1.83963 3.17216 3.30377 1.75296 5.10123 1.41789C8.3775 0.807027 11.1932 3.62269 10.5825 6.89896C10.2474 8.69643 8.82823 10.1606 7.04237 10.5527C5.78837 10.828 4.60263 10.5904 3.63623 10.0201C3.55423 9.97169 3.45697 9.95923 3.36663 9.98936ZM14.6663 10.0006C14.6663 8.00456 13.4111 6.30536 11.6487 5.63843C11.6802 6.11536 11.6553 6.59989 11.5654 7.08223C11.1585 9.26549 9.4271 11.0526 7.25683 11.5292C6.84177 11.6203 6.42317 11.6656 6.00783 11.6656C5.8829 11.6656 5.75943 11.6516 5.6353 11.6435C6.3005 13.4092 8.00137 14.6672 9.9997 14.6672C10.8635 14.6672 11.6701 14.4292 12.3637 14.0197C12.4454 13.9715 12.5422 13.9592 12.6322 13.9892L14.034 14.4564C14.2946 14.5432 14.5425 14.2954 14.4556 14.0348L13.9883 12.6331C13.9583 12.543 13.9706 12.4463 14.0188 12.3646C14.4283 11.671 14.6663 10.8644 14.6663 10.0006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messages-icon.a97cafddfd9ed386348852dd196dd98d.svg";
export { ForwardRef as ReactComponent };